export default __webpack_public_path__ + "static/media/romancePackage.3e367e51.jpg";